import { render, staticRenderFns } from "./PersonFlags.vue?vue&type=template&id=9025be00"
import script from "./PersonFlags.vue?vue&type=script&lang=js"
export * from "./PersonFlags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports